<template>
  <v-container fluid class="crear-venta-container">
    <v-row>
      <v-col cols="12" sm="12" md="5" id="left-pane-venta">
        <v-card>
          <BillHeader />
          <BillBody />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="7">
        <ItemsBillPanel></ItemsBillPanel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ItemsBillPanel from "@/components/CreateBill/ItemsBillPanel";
import BillBody from "@/components/CreateBill/BillBody";
import BillHeader from "@/components/CreateBill/BillHeader";
import { mapGetters, mapActions } from "vuex";

// const {getPromosAll} = api.services.promosService;

export default {
  name: "CreateBill",

  components: {
    ItemsBillPanel,
    BillHeader,
    BillBody
  },

  methods: {
    ...mapActions(["removeItem", "setPromos"]),
    getPromosAll(){},
    deleteItem(id) {
      this.removeItem(id);
    }
  },
  computed: {
    ...mapGetters(["billItems"])
  },
  beforeMount(){
    const promos = this.getPromosAll();
    this.setPromos(promos);
  }
};
</script>

<style>
.crear-venta-container {
  width: 100%;
}

.header__item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 15px 0 15px;
}
.header__item > .header__icon {
  /* border: 1px rgb(214, 208, 208) solid; */
  width: auto;
}

.header__item > .header__title,
.header__item > .header__content {
  /* border: 1px rgb(214, 208, 208) solid; */
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  width: 100%;
}

.header__title {
  color: grey;
}

/* .header__item .cliente{
    padding-top: 3px;
    padding-bottom: 3px;
  } */

.header__content .cliente {
  width: 80%;
  height: 50px;
  background-color: red;
}
/* .header__content > input{ */
/* width: 350px;
    justify-self: center;
    border-bottom: 1px lightgrey solid;
    margin-left: 20px;
    margin-bottom: 2px; */
/* } */
.header__content > span {
  font-weight: bold;
}
#right-pane-venta {
  height: 100vh;
  border-style: dotted;
  border-color: blueviolet;
  border-bottom-width: 1px;
}
</style>
